// Text field styling shared by the login and sign-in code screens.
export const authFieldSx = {
  background: '#fff',
  width: '100%',
  '& .MuiInputBase-root': {
    alignItems: 'center',
  },
  '& .MuiInputBase-input': {
    height: '50px',
    padding: '0 16px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    lineHeight: '0.5',
    outline: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiOutlinedInput-root': {
    boxShadow: 'none',
  },
  '& .MuiOutlinedInput-root.Mui-focused': {
    boxShadow: 'none',
  },
};
